import { entity as E } from "./schema.js";
export const airlines = {
"BB-AIR-01": [
E("air_airport", "Airport", "A network airport with explicit code system and local time zone.", `code_system|CODE(16)|IATA, ICAO or internal namespace
airport_code|CODE(12)|Airport code in that namespace
name|TEXT(160)|Airport name
time_zone|TEXT(80)|IANA time-zone identifier`, ["code_system,airport_code"], "Codes from different namespaces must not be conflated."),
E("air_route", "Airline route", "An airline service route between distinct airports.", `origin_id|>air_airport.id|Departure airport
destination_id|>air_airport.id|Arrival airport
carrier_code|CODE(12)|Operating carrier namespace code
route_code|CODE(40)|Carrier route reference`, ["carrier_code,route_code"], "Origin and destination must differ; routing changes create a new effective schedule."),
E("air_schedule", "Flight schedule version", "A versioned flight service schedule for a route.", `route_id|>air_route.id|Served route
flight_number|CODE(20)|Carrier flight number
version|INTEGER|Schedule version
valid_from|DATE|First operating date
valid_to|DATE|Last operating date
planned_aircraft_type|CODE(20)|Planned fleet type`, ["route_id,flight_number,version"], "Calendar exceptions and codeshare references are separate from the operating service."),
E("air_flight_leg", "Operating flight leg", "A dated occurrence of one operating flight leg.", `schedule_id|>air_schedule.id|Effective flight schedule
service_date|DATE|Local origin service date
leg_no|INTEGER|Sequence within service
scheduled_departure|INSTANT|Departure instant
scheduled_arrival|INSTANT|Arrival instant
status|CODE(20)|Scheduled, operated or cancelled`, ["schedule_id,service_date,leg_no"], "Store actual instants independently of local service date and daylight saving time.")
],
"BB-AIR-02": [
E("air_booking", "Airline reservation", "A reservation issued by an explicit booking authority.", `authority|CODE(40)|Reservation system or carrier
record_locator|CODE(30)|Authority-issued locator
booked_at|INSTANT|Reservation time
status|CODE(20)|Held, confirmed or cancelled`, ["authority,record_locator"], "Locators are scoped to the issuing authority and are not global identities."),
E("air_traveler", "Booked traveler", "A passenger associated with a reservation and shared person record.", `booking_id|>air_booking.id|Reservation
traveler_no|INTEGER|Traveler number
person_id|>pty_person.party_id|Shared person identity
traveler_type|CODE(20)|Adult, child or infant`, ["booking_id,traveler_no"], "Passenger name similarity never merges party records."),
E("air_booking_segment", "Reserved itinerary segment", "A traveler's reserved service on an operating leg.", `traveler_id|>air_traveler.id|Booked traveler
flight_leg_id|>air_flight_leg.id|Operating leg
segment_no|INTEGER|Itinerary position
booking_class|CODE(10)|Reserved class
status|CODE(20)|Requested, confirmed, flown or cancelled`, ["traveler_id,segment_no"], "Reservation status differs from ticket coupon and boarding status.")
],
"BB-AIR-03": [
E("air_ticket", "Ticket document", "A carrier-issued ticket associated with a booked traveler.", `traveler_id|>air_traveler.id|Ticketed traveler
issuer|CODE(20)|Issuing carrier
document_number|CODE(30)|Issuer document reference
issued_at|INSTANT|Issue timestamp
currency|CODE(3)|Document currency`, ["issuer,document_number"], "Traditional ticketing is modeled explicitly; this is not an NDC or ONE Order implementation."),
E("air_coupon", "Ticket coupon", "One ticket coupon for a reserved segment.", `ticket_id|>air_ticket.id|Ticket document
coupon_no|INTEGER|Coupon sequence
segment_id|>air_booking_segment.id|Reserved segment
fare_amount|MONEY|Fare in ticket currency
status|CODE(20)|Open, used, exchanged or refunded`, ["ticket_id,coupon_no"], "Coupon state transitions must reconcile with travel and exchanges."),
E("air_ticket_tax", "Ticket tax or fee", "An explicitly identified charge attached to a ticket.", `ticket_id|>air_ticket.id|Ticket document
line_no|INTEGER|Charge sequence
charge_code|CODE(20)|Tax or fee code
amount|MONEY|Amount in document currency`, ["ticket_id,line_no"], "Tax determination and jurisdiction rules are outside the reference model."),
E("air_document_adjustment", "Ticket exchange or refund", "A monetary adjustment and optional replacement document.", `ticket_id|>air_ticket.id|Adjusted original document
adjustment_reference|CODE(60)|Adjustment identifier
replacement_id|>air_ticket.id?|Replacement ticket
adjustment_kind|CODE(20)|Exchange or refund
amount|MONEY|Adjustment in original document currency
recorded_at|INSTANT|Adjustment timestamp`, ["adjustment_reference"], "Original and replacement documents are retained; exchanged coupons cannot be reused.")
],
"BB-AIR-04": [
E("air_checkin", "Passenger check-in", "A check-in occurrence for a booked flight segment.", `segment_id|>air_booking_segment.id|Traveler and flight segment
checkin_reference|CODE(50)|Check-in transaction reference
checked_in_at|INSTANT|Check-in time
status|CODE(20)|Checked_in, cancelled or boarded`, ["checkin_reference"], "Check-in is distinct from boarding and identity verification."),
E("air_seat_assignment", "Passenger seat assignment", "A seat allocation history for a check-in record.", `checkin_id|>air_checkin.id|Checked-in segment
revision|INTEGER|Assignment version
seat_label|CODE(10)|Aircraft configuration seat label
assigned_at|INSTANT|Assignment timestamp`, ["checkin_id,revision"], "Active assignments must be unique per operating leg and seat."),
E("air_boarding_event", "Passenger boarding event", "Gate acceptance or reversal recorded for a checked-in traveler.", `checkin_id|>air_checkin.id|Passenger check-in
event_no|INTEGER|Gate event sequence
event_kind|CODE(20)|Accepted, offloaded or denied
occurred_at|INSTANT|Gate event timestamp
gate_code|CODE(20)|Gate reference`, ["checkin_id,event_no"], "Boarded totals derive from accepted events net of reversals."),
E("air_service_request", "Passenger service request", "A requested service attached to a traveler segment.", `segment_id|>air_booking_segment.id|Traveler segment
request_no|INTEGER|Request sequence
service_code|CODE(20)|Carrier-controlled service vocabulary
status|CODE(20)|Requested, confirmed or delivered
note|TEXT(300)?|Minimum necessary operational note`, ["segment_id,request_no"], "Sensitive passenger information requires local access and retention policy.")
],
"BB-AIR-05": [
E("air_aircraft_type", "Aircraft type", "A fleet type with reviewed configuration identifiers.", `type_code|CODE(20)|Type namespace code
manufacturer|TEXT(100)|Aircraft manufacturer
model_name|TEXT(100)|Aircraft model
maximum_seats|INTEGER|Reference seat capacity`, ["type_code"], "Aircraft type codes require an explicit operator vocabulary."),
E("air_aircraft", "Aircraft airframe", "An individually identified airframe and its current fleet status.", `type_id|>air_aircraft_type.id|Aircraft type
manufacturer_serial|CODE(60)|Manufacturer serial number
registration|CODE(30)|Current registration
ownership_kind|CODE(20)|Owned or leased
status|CODE(20)|Operational, maintenance or retired`, ["type_id,manufacturer_serial"], "Registration may change; serial identity is retained across registration history."),
E("air_cabin_config", "Aircraft cabin configuration", "A versioned seating and cabin profile for an airframe.", `aircraft_id|>air_aircraft.id|Configured airframe
version|INTEGER|Configuration version
valid_from|DATE|Configuration start
seat_map_reference|TEXT(200)|Reviewed seat map
seat_count|INTEGER|Installed passenger seats`, ["aircraft_id,version"], "Flight-specific seat validity depends on the effective configuration."),
E("air_aircraft_status_event", "Aircraft service status", "A historical fleet status decision.", `aircraft_id|>air_aircraft.id|Airframe
event_no|INTEGER|Status event sequence
status|CODE(20)|Operational, maintenance or retired
effective_at|INSTANT|Effective timestamp
evidence_ref|TEXT(160)|Operational decision evidence`, ["aircraft_id,event_no"], "This record does not certify airworthiness."),
E("air_flight_aircraft_assignment", "Operating aircraft assignment", "A versioned assignment of an airframe to a dated operating flight leg.", `flight_leg_id|>air_flight_leg.id|Operating flight occurrence
aircraft_id|>air_aircraft.id|Assigned airframe
revision|INTEGER|Assignment revision
assigned_at|INSTANT|Assignment decision time
reason|TEXT(300)|Initial allocation or reason for aircraft substitution`, ["flight_leg_id,revision"], "Only the effective assignment is active; overlapping flight duties, configuration and aircraft availability require operational validation.")
],
"BB-AIR-06": [
E("air_crew_member", "Crew member", "An employee's crew identity and primary operating role.", `employee_id|>org_employee.employee_id|Shared employee
crew_number|CODE(40)|Operator crew reference
role_code|CODE(30)|Flight_deck or cabin
base_airport_id|>air_airport.id|Home operating base`, ["employee_id", "crew_number"], "Employment and operational qualifications are separate records."),
E("air_qualification", "Crew qualification", "A dated crew qualification for an aircraft type or duty.", `crew_id|>air_crew_member.id|Qualified crew member
qualification_code|CODE(40)|Qualification vocabulary
valid_from|DATE|Qualification start
valid_to|DATE|Expiry date
evidence_ref|TEXT(160)|Qualification evidence`, ["crew_id,qualification_code,valid_from"], "Qualification authenticity and validity must be verified by the operator."),
E("air_crew_duty", "Crew duty assignment", "A roster-versioned duty on an operating flight leg.", `crew_id|>air_crew_member.id|Assigned crew
flight_leg_id|>air_flight_leg.id|Operating leg
roster_version|INTEGER|Published roster revision
report_at|INSTANT|Duty reporting time
release_at|INSTANT|Expected duty release
position_code|CODE(30)|Assigned duty position`, ["crew_id,flight_leg_id,roster_version"], "Duty, rest and qualification checks require operational rules; no legality solver is supplied.")
],
"BB-AIR-07": [
E("air_component_install", "Installed aircraft component", "A serialized inventory item installed on an airframe.", `aircraft_id|>air_aircraft.id|Airframe
item_id|>inv_item.item_id|Part definition
serial_number|CODE(60)|Manufacturer component serial
position_code|CODE(40)|Installation position
installed_at|INSTANT|Installation time
removed_at|INSTANT?|Removal time`, ["aircraft_id,position_code,installed_at"], "Overlapping installations at the same position must be rejected."),
E("air_work_package", "Aircraft maintenance work package", "A controlled maintenance package for an airframe.", `aircraft_id|>air_aircraft.id|Maintained aircraft
package_number|CODE(40)|Maintenance package reference
opened_on|DATE|Package start
status|CODE(20)|Planned, open or closed`, ["package_number"], "Work-package closure does not independently certify return to service."),
E("air_maintenance_task", "Aircraft maintenance task", "An inspection or service task and its recorded completion.", `package_id|>air_work_package.id|Work package
task_no|INTEGER|Package task sequence
instruction_reference|TEXT(160)|Approved task revision
completed_at|INSTANT?|Completion timestamp
performed_by|>org_employee.employee_id?|Performing employee
result|TEXT(500)?|Recorded inspection or service outcome`, ["package_id,task_no"], "Authorization, tooling and release evidence require operator controls.")
],
"BB-AIR-08": [
E("air_turnaround", "Aircraft turnaround", "A ground-handling occurrence around a dated flight leg.", `flight_leg_id|>air_flight_leg.id|Operating flight leg
turnaround_reference|CODE(40)|Turnaround record reference
stand_code|CODE(20)|Assigned stand
on_block_at|INSTANT?|Actual on-block time
off_block_at|INSTANT?|Actual off-block time`, ["turnaround_reference"], "Airport stand occupancy and movement control are external operational responsibilities."),
E("air_ground_activity", "Ground-handling activity", "One scheduled service in an aircraft turnaround.", `turnaround_id|>air_turnaround.id|Ground-handling occurrence
activity_no|INTEGER|Activity sequence
service_kind|CODE(30)|Fuel, clean, cater, baggage or pushback
provider_id|>pty_party.party_id|Service provider
planned_start|INSTANT|Planned activity start
completed_at|INSTANT?|Completion timestamp`, ["turnaround_id,activity_no"], "Safety precedence and fueling constraints require operating procedures."),
E("air_movement_event", "Flight movement event", "A timed movement or milestone associated with an operating leg.", `flight_leg_id|>air_flight_leg.id|Flight occurrence
event_no|INTEGER|Event sequence
event_kind|CODE(30)|Landing, on_block, off_block or takeoff
occurred_at|INSTANT|Observed instant
source|CODE(40)|Authoritative event source`, ["flight_leg_id,event_no"], "Estimated and actual times must not overwrite each other without provenance.")
],
"BB-AIR-09": [
E("air_baggage", "Checked baggage item", "A tagged baggage item associated with a booked traveler.", `traveler_id|>air_traveler.id|Bag owner
issuer|CODE(20)|Bag-tag issuing carrier
tag_number|CODE(40)|Issued bag-tag reference
issued_at|INSTANT|Issue time
weight_kg|QTY|Measured mass in kilograms`, ["issuer,tag_number,issued_at"], "Tag numbers may be reused over time, so issue occurrence is retained."),
E("air_baggage_leg", "Baggage routing leg", "The planned flight routing of one bag.", `baggage_id|>air_baggage.id|Bag item
flight_leg_id|>air_flight_leg.id|Planned leg
sequence_no|INTEGER|Routing sequence
status|CODE(20)|Planned, loaded, unloaded or missing`, ["baggage_id,sequence_no"], "Baggage routing can differ from passenger routing after an irregularity."),
E("air_baggage_event", "Baggage handling event", "A scan or handling occurrence for a bag.", `baggage_id|>air_baggage.id|Tracked bag
event_no|INTEGER|Handling event sequence
airport_id|>air_airport.id|Event airport
occurred_at|INSTANT|Scan timestamp
event_kind|CODE(30)|Accepted, screened, loaded, transfer or delivered`, ["baggage_id,event_no"], "Missing scan evidence must not be treated as successful delivery."),
E("air_baggage_case", "Baggage irregularity", "A missing, delayed or damaged bag investigation.", `baggage_id|>air_baggage.id|Affected bag
case_number|CODE(50)|Irregularity report reference
opened_at|INSTANT|Report time
case_kind|CODE(20)|Missing, delayed or damaged
status|CODE(20)|Open, located or closed`, ["case_number"], "Case resolution must retain the supporting delivery or compensation evidence.")
],
"BB-AIR-10": [
E("air_cargo_shipment", "Air cargo consignment", "A shipper-to-consignee consignment with an issuer-scoped document.", `consignor_id|>pty_party.party_id|Sending party
consignee_id|>pty_party.party_id|Receiving party
issuer|CODE(20)|Document issuer
airwaybill_reference|CODE(50)|Cargo document reference
weight_kg|QTY|Gross mass`, ["issuer,airwaybill_reference"], "This is a cargo reference structure, not a ONE Record interchange implementation."),
E("air_cargo_piece", "Cargo handling unit", "One independently tracked piece in a consignment.", `shipment_id|>air_cargo_shipment.id|Consignment
piece_no|INTEGER|Piece sequence
handling_reference|CODE(60)|Handling unit label
weight_kg|QTY|Piece mass
special_handling|CODE(40)?|Reviewed handling classification`, ["shipment_id,piece_no"], "Dangerous-goods acceptance and packaging rules require specialized systems."),
E("air_cargo_allocation", "Cargo flight allocation", "Space allocated to a cargo piece on an operating leg.", `piece_id|>air_cargo_piece.id|Cargo piece
flight_leg_id|>air_flight_leg.id|Operating flight
status|CODE(20)|Booked, loaded or offloaded
allocated_at|INSTANT|Allocation time`, ["piece_id,flight_leg_id"], "Capacity and weight-and-balance checks are outside the structural template."),
E("air_cargo_event", "Cargo custody event", "A recorded cargo handover or delivery occurrence.", `piece_id|>air_cargo_piece.id|Tracked piece
event_no|INTEGER|Event sequence
party_id|>pty_party.party_id|Receiving custodian
occurred_at|INSTANT|Custody event time
event_kind|CODE(30)|Accepted, transferred or delivered`, ["piece_id,event_no"], "Custody identity and delivery evidence require explicit verification.")
],
"BB-AIR-11": [
E("air_station_stock", "Airline station stock policy", "Replenishment policy for parts or catering stock at a station.", `airport_id|>air_airport.id|Operating station
item_id|>inv_item.item_id|Part or catering item
location_id|>inv_location.stock_location_id|Stock location
stock_kind|CODE(20)|Aircraft_part or catering
minimum_qty|QTY|Minimum desired stock
uom|CODE(16)|Inventory unit`, ["airport_id,item_id,location_id"], "Airworthiness evidence and food expiry remain separate from stock quantity."),
E("air_stock_reservation", "Flight stock reservation", "Inventory reserved for an operating flight.", `flight_leg_id|>air_flight_leg.id|Flight occurrence
reservation_id|>inv_reservation.reservation_id|Shared inventory reservation
purpose|CODE(30)|Catering, equipment or service_part
required_at|INSTANT|Required delivery time`, ["flight_leg_id,reservation_id"], "Reservation does not imply issue or loading onto an aircraft."),
E("air_stock_replenishment", "Station replenishment request", "A request to restore station inventory.", `policy_id|>air_station_stock.id|Station item policy
request_number|CODE(50)|Replenishment reference
quantity|QTY|Requested quantity
required_on|DATE|Required arrival date
status|CODE(20)|Requested, approved or received`, ["request_number"], "Receipt is confirmed by shared inventory movement records.")
],
"BB-AIR-12": [
E("air_payment", "Airline sales payment", "A received payment or refund associated with a ticket document.", `ticket_id|>air_ticket.id|Sales document
payment_reference|CODE(60)|Payment processor reference
payment_kind|CODE(20)|Receipt or refund
amount|MONEY|Payment magnitude
currency|CODE(3)|Payment currency
value_date|DATE|Payment date`, ["payment_reference"], "Processor tokens and amounts only; no payment-card credentials are included."),
E("air_partner_settlement", "Airline partner settlement", "An agreed settlement with a distribution or interline partner.", `partner_id|>pty_party.party_id|Settlement counterparty
statement_reference|CODE(60)|Partner statement identifier
period_end|DATE|Settlement cutoff
currency|CODE(3)|Settlement currency
net_amount|MONEY|Agreed net amount`, ["partner_id,statement_reference"], "Proration and interline agreements require explicit commercial policies."),
E("air_settlement_line", "Airline settlement line", "A ticket revenue or flight cost allocation to a settlement.", `settlement_id|>air_partner_settlement.id|Partner statement
line_no|INTEGER|Statement line
payment_id|>air_payment.id?|Related payment
flight_leg_id|>air_flight_leg.id?|Related flight cost
amount|MONEY|Allocated amount
journal_id|>fin_journal.journal_id?|Approved ledger journal`, ["settlement_id,line_no"], "Revenue recognition and currency conversion are reviewed accounting decisions.")
]
};
